var checked_conversation_feed = false ;
function populateConversationFeeds() {
	// For conversation feed.
	if (!checked_conversation_feed) {
		checked_conversation_feed = true;
		$(".conversation_component").each(function() {
			var ele = $(this);
			
			var page_type = $("#conversation_feed_page_type").val();
			
			if(page_type == 'staff_profile') {
				getConversationFeedForStaffProfile(ele);
			} else {
			    var feedPath = ele.find(".conversation_feed_url").val();
				getConversationFeed(ele, feedPath);
			}
			
		});
	}
	
}

function getConversationFeedForStaffProfile(element) {
	var ele = element;
	var flinders_uni_default_feed = "https://theconversation.com/institutions/flinders-university-972/articles.atom";

	var spp_social_the_conversation = $('#spp_social_the_conversation');
	
	if(spp_social_the_conversation.length) {
        getConversationFeed(ele, spp_social_the_conversation.prop('href'));
	}
	else {
		getConversationFeed(ele, flinders_uni_default_feed);
	}
	
}

// Striping out articles after profiles in feed url.
function validateConversationFeedUrl(conversation_feed_url) {
	var feed_url = conversation_feed_url;
	
	//if (feed_url.indexOf('profiles') > -1 && feed_url.indexOf('/articles') > -1) {
    if (feed_url.indexOf('/articles') > -1) {
		
		validated_feed_url = feed_url.substr(0,feed_url.indexOf('/articles'));
		
	} else {
		
		validated_feed_url = feed_url;
	}
	// Checking if there is trailing slash then remove it.
	if(validated_feed_url.charAt(validated_feed_url.length-1) == "/") {
		validated_feed_url = validated_feed_url.replace(/\/$/, "");
	}
	return validated_feed_url;
}

// Conversation feed.
function getConversationFeed(element, profile) {
    var url_conversation_xml = '/flinders-services/staff/conversation';
    var profileUrl = 'https://theconversation.com/institutions/flinders-university-972';

    if (profile) {
        profileUrl = validateConversationFeedUrl(profile);
    }

    url_conversation_xml = url_conversation_xml + '/?profile=' + profileUrl;
    
	var container = element;
	 
    $.ajax({
    	url: url_conversation_xml,
    	method: "GET",
    	beforeSend: function(){
            $('.ajax-loader').css("visibility", "visible");
          },
    	dataType: "xml",
    	crossDomain: true,
        success: function (data) {
        	$(data).find("entry").each(function (index, value) { 
        		var ele = $(this);
        		var url = ele.find("link").attr("href");
        		var title = ele.find("title").text();
        		var date = moment(ele.find("published").text()).format("DD-MMMM-YYYY");
        		
        		var add_to_list = {"title": title, "date": date, "url": url};
        		container.find('.conversation_component_section_wrap').append(Handlebars.compile($("#component_section_item").html())(add_to_list));
                if(index == 2) {
                    return false;
                }
            });
        	$(data).find("Error").each(function (index, value) { 
        		var ele = $(this);
        		errorMessage(ele.find("name").text());
        	});
        	
        }, // End of success
        complete: function(){
    	    $('.ajax-loader').css("visibility", "hidden");
    	},
    	error: function (jqXHR, textStatus, exception, errorThrown) {
            ajaxErrorHandler(jqXHR, textStatus, exception, errorThrown)
      	}
    });
    container.find('.conversation_component_read_more .conversation_component_read_more_button').prop('href', profileUrl );
}
